export default {
      id: "flag-fi-usage",
      viewBox: "0 10 36 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#flag-fi",
      toString: function () {
        return this.url;
      }
    }